import { ErrorHandler, Injectable, inject } from "@angular/core";
import { logError } from "@storebrand-digital/common-datadog";
import { DispatcherService, Signal } from "src/app/services/dispatcher.service";
import { isChunkLoadError } from "src/app/utils/errors";

@Injectable()
export class AppErrorHandler implements ErrorHandler {
  private readonly dispatcherService = inject(DispatcherService);

  public handleError(error: Error): void {
    if (isChunkLoadError(error)) {
      this.dispatcherService.dispatch(Signal.ChunkLoadError, AppErrorHandler.name);
      return;
    }

    // Forward the uncaught error to Datadog RUM. logError → datadogRum.addError, which preserves
    // the Error's message and (symbolicated) stack.
    logError(error);
  }
}
